<template>
  <div class="pagination-footer">
    <span>Exibindo {{ displayStart }} a {{ displayEnd }} de {{ total }}</span>
    <div class="pagination-controls">
      <label>
        Linhas por página
        <select :value="pageSize" class="pagination-select" :disabled="loading" @change="changePageSize">
          <option v-for="size in pageSizeOptions" :key="size" :value="size">{{ size }}</option>
        </select>
      </label>
      <span>Página {{ displayedPage }} de {{ totalPages }}</span>
      <div class="pagination-buttons">
        <button type="button" aria-label="Página anterior" :disabled="displayedPage <= 1 || loading" @click="$emit('change-page', page - 1)"><AppIcon name="chevronLeft" /></button>
        <button class="current-page" type="button" aria-current="page">{{ displayedPage }}</button>
        <button type="button" aria-label="Próxima página" :disabled="displayedPage >= totalPages || loading" @click="$emit('change-page', page + 1)"><AppIcon name="chevronRight" /></button>
      </div>
    </div>
  </div>
</template>

<script>
import AppIcon from './AppIcon.vue'

export default {
  name: 'GridPagination',
  components: { AppIcon },
  props: {
    page: { type: Number, default: 1 },
    pageSize: { type: Number, default: 20 },
    total: { type: Number, default: 0 },
    pageSizeOptions: { type: Array, default: () => [20, 40, 80, 100] },
    loading: { type: Boolean, default: false }
  },
  emits: ['change-page', 'change-page-size'],
  computed: {
    totalPages () { return this.total === 0 ? 0 : Math.ceil(this.total / this.pageSize) },
    displayedPage () { return this.totalPages === 0 ? 0 : Math.min(this.page, this.totalPages) },
    displayStart () { return this.total === 0 ? 0 : ((this.displayedPage - 1) * this.pageSize) + 1 },
    displayEnd () { return this.total === 0 ? 0 : Math.min(this.displayedPage * this.pageSize, this.total) }
  },
  methods: {
    changePageSize (event) { this.$emit('change-page-size', Number(event.target.value)) }
  }
}
</script>
